<template>
  <generic-modal
    size
    :title="$t('provider')"
    icon="user tie"
    image="/images/icons/provider.png"
    v-bind:scrolling="false"
    v-on:destroy="destroy"
    v-bind:on_finished="this.finished"
  >
    <div class="description">
      <div class="ui form" ref="form">
        <h3 class="ui dividing header">
          <i class="info circle small icon"></i>
          {{ $t("basic information") }}
        </h3>
        <div class="field">
          <label for>{{ $t("name") }}</label>
          <input type="text" name="name" v-model="name" />
        </div>
        <div class="field">
          <label for>{{ $t("description") }}</label>
          <textarea name="description" rows="2" v-model="description"></textarea>
        </div>
        <h3 class="ui dividing header">
          <i class="users small icon"></i>
          {{ $t("contacts") }}
        </h3>
        <div class="ui secondary contacts pointing menu">
          <a
            class="item"
            v-for="(contact, index) in contacts"
            :key="index"
            :data-tab="contact.uuid"
          >{{contact.name}}</a>
          <a class="item" @click="add_contact">
            <i class="plus icon"></i>
          </a>
        </div>
        <div
          class="ui tab segment"
          v-for="(contact, index) in contacts"
          :key="index"
          :data-tab="contact.uuid"
        >
          <div class="field">
            <label for>{{ $t("name") }}</label>
            <input type="text" name="name" v-model="contacts[index].name" />
          </div>
          <div class="field">
            <label for>{{ $t("phone") }}</label>
            <input type="text" name="phone" v-model="contacts[index].phone" />
          </div>
          <div class="field">
            <label for>{{ $t("email") }}</label>
            <input type="text" name="email" v-model="contacts[index].email" />
          </div>
          <div class="ui red icon labeled button" @click="remove_contact(contact, index)">
            <i class="trash icon"></i>
            {{ $t("delete") }}
          </div>
        </div>
        <div class="ui error message"></div>
      </div>
    </div>
  </generic-modal>
</template>

<script>
import { local_api /*, error_toast*/ } from "@/utils";
import { v4 } from "uuid";
// import { deepClone } from "lodash";
import GenericModal from "@/components/GenericModal";

export default {
  components: {
    "generic-modal": GenericModal
  },
  computed: {},
  props: { provider: Object },
  data() {
    return {
      name: "",
      description: "",
      contacts: [],
      uuid: undefined
    };
  },
  methods: {
    finished() {
      let vm = this;
      return new Promise(function(resolve, reject) {
        let isValid = window.jQuery(vm.$refs.form).form("validate form");

        if (!isValid) reject();
        else {
          let setup = {
            contacts: vm.contacts
          };

          local_api(vm, "post", "/provider/do-save", {
            i: vm.uuid,
            n: vm.name,
            d: vm.description,
            s: JSON.stringify(setup)
          })
            .then(provider => {
              vm.$emit("succedded", provider);
              resolve();
            })
            .catch(err => {
              reject(err);
            });
        }
      });
    },
    destroy() {
      this.$emit("destroy");
      // this.$destroy();
    },
    add_contact() {
      this.contacts.push({
        uuid: v4(),
        name: `${this.$t("contact")} ${this.contacts.length + 1}`,
        phone: "",
        email: ""
      });
    },
    remove_contact(contact, index) {
      let vm = this;
      vm.$alertify.confirm(
        vm.$t("are you sure to remove contact?"),
        function() {
          vm.contacts.splice(index, 1);
        }
      );
    }
  },
  mounted() {
    let vm = this;
    window.jQuery(vm.$refs.form).form({
      fields: {
        name: ["empty"]
      }
    });

    if (this.provider && this.provider.uuid) {
      this.name = this.provider.name;
      this.description = this.provider.description;
      this.uuid = this.provider.uuid;
      this.contacts = this.provider.setup.contacts || [];
    }
  },
  watch: {
    contacts() {
      setTimeout(() => {
        window.jQuery(".ui.contacts.menu .item").tab();
      }, 50);
    }
  },
  updated: function() {}
};
</script>
